export const environment = { VERSION: require('../../package.json').version }